// extracted by mini-css-extract-plugin
module.exports = {"DisableSend":"ReceiptModal_DisableSend__2X50i"};